@if(!noHeader) {
	<branding-logo class="logo">
	</branding-logo>
}

<div class="infoView" [class.has-banner]="hasBanner">
	<header class="info-header">
		<div>
			<h1>{{webcast.title}}</h1>
			<div>
				{{webcast.startDate | vbDateTimeMedium}} - {{webcast.endDate | vbDateTimeMedium}}
			</div>
		</div>
		<ng-content select="[headerSlot]"></ng-content>
	</header>

	<div class="info-container" [class.has-banner]="hasBanner">

		<div class="banner-pane">
			@if (brandingSettings.bannerImageUri) {
				<img class="banner-img" [src]="brandingSettings.bannerImageUri"/>
			}
			@if (webcast.description) {
				<vb-ui-toggle-content-display [minHeight]="80" class="padding-top-10">
					<div [innerHTML]="webcast.description | safeHtml" class="description" #vbUiToggleItem>
					</div>
				</vb-ui-toggle-content-display>
			}
			@if(brandingSettings.speakerProfiles?.length) {
				<webcast-speakers [speakers]="brandingSettings.speakerProfiles">
				</webcast-speakers>
			}
		</div>

		@if (!noContent) {
			<div class="info-pane">
				<ng-content></ng-content>
			</div>
		}
		@if (brandingSettings.speakerProfiles?.length) {
			<webcast-speakers class="mobile-speakers" [speakers]="brandingSettings.speakerProfiles">
			</webcast-speakers>
		}
	</div>
</div>
